/**
 * DashboardGreeting — Time-of-day greeting + practitioner name.
 *
 * Caller is responsible for deriving the greeting key from the hour and passing
 * the resolved string directly; this component stays pure (no Date logic inside).
 */

import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

interface DashboardGreetingProps {
  practitionerName: string;
  greeting: string;
}

export const DashboardGreeting: React.FC<DashboardGreetingProps> = React.memo(
  function DashboardGreeting({ practitionerName, greeting }) {
    return (
      <View style={styles.container}>
        <Text style={styles.greeting}>{greeting}</Text>
        <Text style={styles.name}>{practitionerName}</Text>
      </View>
    );
  }
);

const styles = StyleSheet.create({
  container: {
    paddingTop: 20,
    paddingBottom: 16,
  },
  greeting: {
    fontSize: 12,
    fontWeight: '500',
    color: '#A1A1AA',
    textTransform: 'uppercase',
    letterSpacing: 0.8,
  },
  name: {
    fontSize: 20,
    fontWeight: '800',
    color: '#18181B',
    marginTop: 2,
  },
});
